/** "Mar 4" — the axis label a daily snapshot gets. */
export function formatSnapshotDay(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/**
 * The day a snapshot is *about*.
 *
 * `period_end` is exclusive — the midnight after the day that was measured —
 * so the readable "as of" date is one day earlier.
 */
export function snapshotDate(periodEnd: string): string {
  const date = new Date(periodEnd);
  date.setUTCDate(date.getUTCDate() - 1);
  return formatSnapshotDay(date.toISOString());
}
